import tables from './tables';
import utils from '../utils';

const getPlayersByBrandFilter = async (brandFilter, token) => {
  try {
    const { data: players } = await utils.getFromMikMakFirebaseService(
      `get/${tables.players}?orderBy=filterKey&equalTo=${brandFilter}`,
      token,
    );

    return players;
  } catch (e) {
    throw `Error getting players by brand filter ${brandFilter}: ${e}`;
  }
};

const getPlayerById = async (id, token) => {
  try {
    const { data: player, success } = await utils.getFromMikMakFirebaseService(
      `getById/${tables.players}/${id}`,
      token,
    );

    if (!success) return;

    return player;
  } catch (e) {
    throw `Error getting player by id ${id} :${e}`;
  }
};

const setPlayer = async (player, token) => {
  const { id } = player;

  await utils.postToMikMakFirebaseService(`set/${tables.players}/${id}`, player, token);
  await utils.callProductService(`refreshSingleLivePlayerData?playerId=${id}`);

  return player;
};

export default {
  getPlayersByBrandFilter,
  getPlayerById,
  setPlayer,
};
